import React from 'react';
import { useTranslation } from 'react-i18next';
import HeroImage from '../../../assets/images/residency-passport/papua-new-guinea/hero-image.jpg';
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import PageList from "../../../components/Constant/List/List";
import { GoDotFill } from "react-icons/go";
import CTA from "../../../components/Constant/cta/CTA";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Button from "../../../components/Constant/button/Button";
import SEO from "../../../utils/SEO";

export default function DiplomaticPassportPapuaNewGuinea () {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.diplomatic-passport-papua-new-guinea.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    const BreadCrumbsData = [
        { name: tp('breadcrumbs.parent', 'Offshore Advisory'), link: '/' },
        {
            name: tp('breadcrumbs.self', 'Diplomatic Passport – Papua New Guinea'),
            link: '/diplomatic-passport-papua-new-guinea',
        },
    ];

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                url="/diplomatic-passport-papua-new-guinea"
            />

            <section className='banking-license-section section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='banking-license-container container'>
                    <br/>

                    <h1 className='section-title'>
                        {tp('h1')}
                    </h1>

                    <div className='grid-container'>
                        <div className='flex-start'>
                            <p className='page-paragraph'>
                                {tp('intro.p1')}
                            </p>
                            <Button
                                text={tp('intro.button')}
                                link="/contact"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImage} />
                    </div>

                    <div className='flex-start'>
                        <br/>
                        <h3 className='page-title'>{tp('definition.title')}</h3>
                        <p className='page-paragraph'>
                            <span dangerouslySetInnerHTML={{ __html: tp('definition.p1') }} />
                        </p>

                        <h3 className='page-title'>{tp('qualifies.title')}</h3>
                        <p className='page-paragraph'>
                            {tp('qualifies.p1')}
                        </p>
                        <PageList
                            items={obj('qualifies.items').map(item => ({ ...item, icon: GoDotFill }))}
                        />
                        <p className='page-paragraph'>
                            {tp('qualifies.p2')}
                        </p>

                        <h3 className='page-title'>{tp('services.title')}</h3>
                        <p className='page-paragraph'>
                            {tp('services.p1')}
                        </p>
                        <PageList
                            items={obj('services.items').map(item => ({ ...item, icon: GoDotFill }))}
                        />

                        <h3 className='page-title'>{tp('benefits.title')}</h3>
                        <p className='page-paragraph'>
                            {tp('benefits.p1')}
                        </p>
                        <PageList
                            items={obj('benefits.items').map(item => ({ ...item, icon: GoDotFill }))}
                        />
                        <p className='page-paragraph'>
                            {tp('benefits.p2')}
                        </p>

                        <h3 className='page-title'>{tp('whyUs.title')}</h3>
                        <PageList
                            items={obj('whyUs.items').map(item => ({ ...item, icon: GoDotFill }))}
                        />

                        <h3 className='page-title'>{tp('notice.title')}</h3>
                        <p className='page-paragraph'>
                            {tp('notice.p1')}
                        </p>

                        <h3 className='page-title'>{tp('comparison.title')}</h3>
                        <p className='page-paragraph'>
                            {tp('comparison.p1')}
                        </p>
                        <PageList
                            items={obj('comparison.items').map(item => ({ ...item, icon: GoDotFill }))}
                        />
                        <p className='page-paragraph'>
                            {tp('comparison.p2')}
                        </p>

                        <h3 className='page-title'>{tp('documents.title')}</h3>
                        <p className='page-paragraph'>
                            {tp('documents.p1')}
                        </p>
                        <PageList
                            items={obj('documents.items').map(item => ({ ...item, icon: GoDotFill }))}
                        />
                        <p className='page-paragraph'>
                            {tp('documents.p2')}
                        </p>

                        <FAQList data={obj('faq.items')} title={tp('faq.title')}/>
                    </div>

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/contact"
                    />
                </div>
            </section>
        </main>
    );
}
